module.exports = __webpack_public_path__ + "assets/img/business-ecology-icon6.b261ddf0.png";